import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
  plus1et5dysousgt9 as plus,
} from './LocalDate.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance_0 } from './DateTimeUnit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { Companion_instancengy76erk0rf3 as Companion_instance } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Progressions.mjs';
import {
  get_sizeUnsafe34uncbw86p6vc as get_sizeUnsafe,
  containsUnsafe3ldznmwv9m694 as containsUnsafe,
} from './internal/math.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.EMPTY_1 = LocalDateRange().new_kotlinx_datetime_LocalDateRange_231qzx_k$(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 2), LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(1970, 1, 1));
      }
      fromRangeTo_z28h6r_k$(start, endInclusive) {
        return LocalDateRange().new_kotlinx_datetime_LocalDateRange_231qzx_k$(start, endInclusive);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID) {
    Companion_instance_1;
    new (Companion())();
  }
  return Companion_instance_0;
}
var LocalDateRangeClass;
function LocalDateRange() {
  if (LocalDateRangeClass === VOID) {
    class $ extends LocalDateProgression() {
      constructor(start, endInclusive) {
        return new.target.new_kotlinx_datetime_LocalDateRange_231qzx_k$(start, endInclusive);
      }
      static new_kotlinx_datetime_LocalDateRange_231qzx_k$(start, endInclusive) {
        Companion_getInstance_1();
        return this.new_kotlinx_datetime_LocalDateProgression_hs0smu_k$(start, endInclusive, 1n);
      }
      get_start_iypx6h_k$() {
        return this.first_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.last_1;
      }
      get_endExclusive_pmwm6k_k$() {
        if (this.last_1.equals(Companion_getInstance().MAX_1)) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes LocalDate.MAX.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return plus(this.get_endInclusive_r07xpi_k$(), 1, Companion_getInstance_0().DAY_1);
      }
      contains_pio7lx_k$(value) {
        var tmp = !(value == null) ? value : THROW_CCE();
        if (!(tmp instanceof LocalDate()))
          return false;
        return this.first_1.compareTo_e7gwgq_k$(value) <= 0 && value.compareTo_e7gwgq_k$(this.last_1) <= 0;
      }
      contains_aljjnj_k$(element) {
        if (!(element instanceof LocalDate()))
          return false;
        return this.contains_pio7lx_k$(element instanceof LocalDate() ? element : THROW_CCE());
      }
      contains_3tkdvy_k$(value) {
        return this.contains_pio7lx_k$(value instanceof LocalDate() ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return this.first_1.compareTo_e7gwgq_k$(this.last_1) > 0;
      }
      toString() {
        return this.first_1.toString() + '..' + this.last_1.toString();
      }
    }
    initMetadataForClass($, 'LocalDateRange', VOID, VOID, [ClosedRange(), OpenEndRange()]);
    LocalDateRangeClass = $;
  }
  return LocalDateRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var LocalDateProgressionClass;
function LocalDateProgression() {
  if (LocalDateProgressionClass === VOID) {
    class $ {
      static new_kotlinx_datetime_LocalDateProgression_nppcft_k$(longProgression) {
        var $this = createThis(this);
        $this.longProgression_1 = longProgression;
        $this.first_1 = Companion_getInstance().fromEpochDays_a3paq6_k$($this.longProgression_1.first_1);
        $this.last_1 = Companion_getInstance().fromEpochDays_a3paq6_k$($this.longProgression_1.last_1);
        return $this;
      }
      static new_kotlinx_datetime_LocalDateProgression_hs0smu_k$(start, endInclusive, step) {
        return this.new_kotlinx_datetime_LocalDateProgression_nppcft_k$(Companion_instance.fromClosedRange_mt5zpf_k$(start.toEpochDays_tp9eth_k$(), endInclusive.toEpochDays_tp9eth_k$(), step));
      }
      iterator_jk1svi_k$() {
        return new (LocalDateProgressionIterator())(this.longProgression_1.iterator_jk1svi_k$());
      }
      isEmpty_y1axqb_k$() {
        return this.longProgression_1.isEmpty_y1axqb_k$();
      }
      toString() {
        return this.longProgression_1.step_1 > 0n ? this.first_1.toString() + '..' + this.last_1.toString() + ' step ' + this.longProgression_1.step_1.toString() + 'D' : this.first_1.toString() + ' downTo ' + this.last_1.toString() + ' step ' + this.longProgression_1.step_1.toString() + 'D';
      }
      get_size_woubt6_k$() {
        return get_sizeUnsafe(this.longProgression_1);
      }
      contains_pio7lx_k$(value) {
        var tmp = !(value == null) ? value : THROW_CCE();
        if (!(tmp instanceof LocalDate()))
          return false;
        return containsUnsafe(this.longProgression_1, value.toEpochDays_tp9eth_k$());
      }
      contains_aljjnj_k$(element) {
        if (!(element instanceof LocalDate()))
          return false;
        return this.contains_pio7lx_k$(element instanceof LocalDate() ? element : THROW_CCE());
      }
      equals(other) {
        var tmp;
        if (other instanceof LocalDateProgression()) {
          tmp = this.longProgression_1.equals(other.longProgression_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.longProgression_1.hashCode();
      }
    }
    initMetadataForClass($, 'LocalDateProgression', VOID, VOID, [Collection()]);
    LocalDateProgressionClass = $;
  }
  return LocalDateProgressionClass;
}
var LocalDateProgressionIteratorClass;
function LocalDateProgressionIterator() {
  if (LocalDateProgressionIteratorClass === VOID) {
    class $ {
      constructor(iterator) {
        this.iterator_1 = iterator;
      }
      hasNext_bitz1p_k$() {
        return this.iterator_1.hasNext_bitz1p_k$();
      }
      next_20eer_k$() {
        return Companion_getInstance().fromEpochDays_a3paq6_k$(this.iterator_1.next_20eer_k$());
      }
    }
    initMetadataForClass($, 'LocalDateProgressionIterator');
    LocalDateProgressionIteratorClass = $;
  }
  return LocalDateProgressionIteratorClass;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance5oz1i6ks5glj,
};
//endregion

//# sourceMappingURL=LocalDateRange.mjs.map
